module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "sigilnotintoc1",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("The following pages form an abridged translation of a book published in 1916 by Freiherrn von Forstner, commander of the first German U-boat. It was written with the somewhat careless haste of a man who took advantage of disconnected moments of leisure, and these moments were evidently subject to abrupt and prolonged interruptions. Many repetitions and trivial incidents have been omitted in this translation; but, in order to express the personality of the Author, the rendering has been as literal as possible, and it shows the strange mixture of sentimentality and ferocity peculiar to the psychology of the Germans.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "Page_viii",
      "title": "[viii]"
    }
  }), _vm._v("Part of the book gives a technical description,—not so much of the construction of a submarine as of the nature of its activities,—which presents us an unusual opportunity to glean a few valuable facts from this personal and intimate account of a German U-boat. We are inclined to a certain grim humor in borrowing the candid information given to us Americans so unconsciously by Freiherrn von Forstner, for he could hardly suppose it would fall into the hands of those who would join the fighting ranks of the "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("hated enemy")]), _vm._v(", as, in his bitter animosity, he invariably calls the English whenever he refers to them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Several chapters in this book are simple narratives of the commander's own adventures during the present naval warfare waged against commerce. "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "Page_ix",
      "title": "[ix]"
    }
  }), _vm._v("His attempts at a lighter vein often provoke a smile at the quality of his wit, but he is not lacking in fine and manly virtues. He is a loyal comrade; a good officer concerned for the welfare of his crew. He is even kindly to his captives when he finds they are docile victims. He is also willing to credit his adversary with pluck and courage. He is never sparing of his own person, and shows admirable endurance under pressure of intense work and great responsibility. He is full of enthusiastic love for his profession, and in describing a storm at sea his rather monotonous style of writing suddenly rises to eloquence. But in his exalted devotion to the Almighty War Lord, and to the Fatherland, he openly reveals his fanatical joy in the nefarious work he has to perform.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "Page_x",
      "title": "[x]"
    }
  }), _vm._v("It is difficult to realize that this ardent worship of detail, and this marvelous efficiency in the conservation of every resource, are applied to a weapon of destruction which directs its indiscriminate attacks against women and children, hospital transports, and relief ships. Nothing at the present day has aroused such fear as this invisible enemy, nor has anything outraged the civilized world like the tragedies caused by the German submarines.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("This small volume may offer new suggestions to those familiar with the science of submarine construction, and it may also shed a little light, even for lay readers, on a subject which for the last three years has taken a preëminent place in the history of the War.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "INTRODUCTION"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "Page_xi",
      "title": "[xi]"
    }
  }), _c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0